<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-6"><a href="#/High_Stakes2#Contents-A">Epigraph</a></p>
<p class="fp para-style-override-3">“I have an agreement with Father Time. <br/>I don’t mess with him, and he don’t mess with me.”</p>
<p class="fp para-style-override-4">—Bernard Hopkins, age 49, <br/>world light-heavyweight boxing champion</p>
<p class="fp para-style-override-3">“Life’s not the breaths you take but the moments <br/>that take your breath away.”</p>
<p class="fp para-style-override-4">—George Strait</p>
<p class="fp para-style-override-5">“Something, like nothing, happens anywhere.”</p>
<p class="fp para-style-override-6">—Phillip Larkin</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// High_Stakes-5.vue?516d8cac